// src/pages/ForgedTwoPiece.jsx
import React from "react";
import { Link } from "react-router-dom";
import AutoVideo from "../components/AutoVideo";
import StyleTileGrid from "../components/StyleTileGrid";
import { TWO_PIECE_STYLES } from "../data/twoPieceStyles"; // <-- you'll create this file similar to monoblockStyles

export default function ForgedTwoPiece() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-16 text-neutral-900">
      {/* ---- HERO: video + copy + Request button ---- */}
      <h1 className="text-3xl font-bold mb-6">Forged 2-Piece</h1>

      <div className="grid md:grid-cols-2 gap-8 mb-10">
        <div className="rounded-2xl overflow-hidden border border-neutral-200">
          <AutoVideo
            srcMp4="/assets/video/twopiece.mp4"
            // poster="/assets/posters/twopiece.jpg"
            className="aspect-video"
          />
        </div>

        <div className="space-y-4">
          <p className="text-neutral-700">
            Our 2-Piece Forged Series blends performance and design flexibility.
            Built from aerospace-grade forged aluminum, these wheels feature a
            forged center and a lightweight spun-forged barrel — allowing for
            deeper concavity, more lip depth, and limitless finishes.
            Perfect for those who demand both function and form.
          </p>

          <ul className="list-disc list-inside text-neutral-800 mb-6">
            <li>Forged 6061-T6 aluminum centers + spun forged barrels</li>
            <li>Sizes from 18" – 30" available</li>
            <li>Custom offsets, widths, and step/reverse lips</li>
            <li>Exposed or hidden hardware options</li>
            <li>Color-matched or contrasting bolts</li>
            <li>Available in floating center cap design</li>
            <li>Lifetime Structural Warranty*</li>
            <li>Average production time: 4–6 weeks</li>
          </ul>

          <Link
            to="/build-your-custom-wheels"
            className="inline-block px-6 py-3 bg-black text-white rounded-xl font-semibold hover:bg-neutral-800 transition"
          >
            Request a Quote
          </Link>
        </div>
      </div>

      {/* ---- TILES: choose your style ---- */}
      <h2 className="text-2xl font-semibold mb-4">Choose Your Style</h2>
      <StyleTileGrid styles={TWO_PIECE_STYLES} />
    </section>
  );
}
